import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import IndustrialSales from "./sections/IndustrialSales";
import Reach from "./sections/Reach";
import Sectors from "./sections/Sectors";
import Advantage from "./sections/Advantage";
import Partners from "./sections/Partners";
import Partnership from "./sections/Partnership";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <IndustrialSales />
      <Reach />
      <Sectors />
      <Advantage />
      <Partners />
      <Partnership />
      <Footer />
    </div>;
}